// extracted by mini-css-extract-plugin
export default {"app__wrapper":"app_app__wrapper__+aeJE","appHeader":"app_appHeader__N7YR4","content__wrapper":"app_content__wrapper__Mm7EF","emptyText":"app_emptyText__11zUS"};